import { render } from "./InfoLoraInitPage.vue?vue&type=template&id=a4e5b642&scoped=true"
import script from "./InfoLoraInitPage.vue?vue&type=script&lang=js"
export * from "./InfoLoraInitPage.vue?vue&type=script&lang=js"

import "./InfoLoraInitPage.vue?vue&type=style&index=0&id=a4e5b642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e5b642"]])

export default __exports__